<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div v-if="created" class="alert alert-success" role="status">{{ created.name }} {{$t('notifications.created')}}.</div>
          <div v-if="updated" class="alert alert-success" role="status">{{ updated.name }} {{$t('notifications.updated')}}.</div>
          <div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
          <div v-if="deleteError" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXSBBatchNumberList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
<!--            <div class="card-header">-->
<!--              <h4 class="card-title">{{$t('views.exsbbatchnumber.update.title')}} {{ item && item['title'] }}</h4>-->
<!--            </div>-->
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXSBBatchNumberForm
                          v-if="item"
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations"
                          :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBBatchNumberForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'

export default {
  components: {
    EXSBBatchNumberForm
  },

  data () {
    return {
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBBatchNumberUpdate')
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbbatchnumber/update/isLoading',
      error: 'exsbbatchnumber/update/error',
      deleteError: 'exsbbatchnumber/del/error',
      deleteLoading: 'exsbbatchnumber/del/isLoading',
      created: 'exsbbatchnumber/create/created',
      deleted: 'exsbbatchnumber/del/deleted',
      retrieved: 'exsbbatchnumber/update/retrieved',
      updated: 'exsbbatchnumber/update/updated',
      violations: 'exsbbatchnumber/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBBatchNumberList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbbatchnumber/create/reset',
      deleteItem: 'exsbbatchnumber/del/del',
      delReset: 'exsbbatchnumber/del/reset',
      retrieve: 'exsbbatchnumber/update/retrieve',
      updateReset: 'exsbbatchnumber/update/reset',
      update: 'exsbbatchnumber/update/update',
      updateRetrieved: 'exsbbatchnumber/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbbatchnumber ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
